import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../../../../common/Header";
import Footer from "../../../../common/Footer";
import image1 from "../../../../assets/people/peoplebannerimg.png";
import img1 from "../../../../assets/people/img1.jpeg";
import img2 from "../../../../assets/people/img2.jpeg";
import img3 from "../../../../assets/people/img3.jpg";
import img4 from "../../../../assets/MohammedSijahudheenEK.jpg";
import img5 from "../../../../assets/people/img5.jpeg";
import img6 from "../../../../assets/people/img6.jpeg";
import img7 from "../../../../assets/people/img7.jpeg";
import img8 from "../../../../assets/people/img8.jpeg";
import img9 from "../../../../assets/people/img9.jpeg";
import img10 from "../../../../assets/people/img10.jpeg";
import img11 from "../../../../assets/people/img11.png";
import img12 from "../../../../assets/people/img12.jpeg";
import img13 from "../../../../assets/MohammedNisham.jpeg";
import LeftSideNavigation from "../../../../common/LeftSideNavigation";

const ScrollContainer = styled("div")(({ theme }) => ({
  display: "flex",
  overflowX: "auto",
  overflowY: "hidden",
  scrollSnapType: "x mandatory",
  scrollBehavior: "smooth",
  height: "100%",
  width: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
}));

const ScrollItem = styled("div")({
  flex: "0 0 100%",
  scrollSnapAlign: "start",
  height: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
});

const ScrollImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
  margin: 0,
  padding: 0,
});

const DotsContainer = styled("div")(({ theme }) => ({
  position: "absolute",
  bottom: "20px",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  zIndex: 10,
  pointerEvents: "auto",
}));

const Dot = styled("div")(({ active }) => ({
  width: "12px",
  height: "12px",
  borderRadius: "50%",
  cursor: "pointer",
  backgroundColor: active ? "#fff" : "rgba(255,255,255,0.5)",
  transition: "background-color 0.3s ease",
  "&:hover": {
    backgroundColor: "white",
    transform: "scale(1.2)",
  },
}));

const Project = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const scrollRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const images = [image1, image1]; // Using same image twice for demo, replace with actual images
  const [scrolled, setScrolled] = useState(false);
  const contentRef = useRef(null);

  const handleDotClick = (index) => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollWidth = container.scrollWidth;
    const itemWidth = scrollWidth / images.length;
    container.scrollTo({ left: itemWidth * index, behavior: "smooth" });
    setCurrentIndex(index);
  };

  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollLeft = container.scrollLeft;
    const itemWidth = container.offsetWidth;
    const index = Math.round(scrollLeft / itemWidth);
    setCurrentIndex(index);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      setScrolled(scrollTop > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % images.length;
      setCurrentIndex(nextIndex);
      container.scrollTo({
        left: container.clientWidth * nextIndex,
        behavior: "smooth",
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollWidth = container.scrollWidth;
      const itemWidth = scrollWidth / images.length;
      const newIndex = Math.round(container.scrollLeft / itemWidth);
      setCurrentIndex(newIndex);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  const teamCategories = [
    {
      title: "Project Personals",
      members: [
        {
          src: img3,
          name: "Habeebulla",
          position: "Research Fellow",
          email: "habeeburahmankdt@gmail.com",
          qualifications: [
            "M. Sc. Marine Biology (2021-23) From Department of Ocean Studies and Marine Biology, Port Blair Campus, Pondicherry University, Andaman and Nicobar Islands",
            "B. Sc. Aquaculture (2018-21) From Government College of Arts and Science, Androth Island, UT of Lakshadweep",
            "5 months of experience as (Young professional -I) in “Reliable Seed Production of Brackishwater Finfishes” at ICAR- Central Institute of Brackishwater Aquaculture, Muttukadu, Chennai.",
          ],
          description: "Working on field research and biodiversity projects.",
          fullProfile1:
            "Completed hands-on training programme in “Improved Technologies for Breeding, Seed Production and Farming of Candidate Brackishwater Finfishes” at ICAR- Central Institute of Brackishwater Aquaculture, Chennai.",

          fullProfile2:
            "Participated in the International Conference on Frontiers in Marine Science – MARICON 2024 organized by the School of Marine Sciences, Cochin University of Science and Technology, Kerala. Completed a high-end workshop on “Hands-on Training on Corals and Coral Associated Faunal communities: Taxonomy and Monitoring” organized by Zoological Survey of India (ZSI), Kolkata.",

          fullProfile3:
            "Undergone hands-on training on “DNA Taxonomy and Phylogeny” organized by Centre for Climate Change Studies, Sathyabama Institute of Science and Technology, Chennai, India. Completed Open and Advanced Open Water Diver courses from ESMUC dive academy, Kadmath.",
        },

        {
          src: img4,
          name: "Mohammed Sijahudheen EK",
          position: "Research Fellow",
          email: "mohdsijahudheen1121@gmail.com",
          qualifications: [
            "BSc. Biotechnology and Botany – St. Berchmans College, Chanaganassery, Kottayam, Kerala (2018-21)",
            "MSc. Marine Biology – Kerala University of Fisheries and Ocean Studies (KUFOS), Panangad, Kochi, Kerala (2022-24)",
            "One year research experience in Seaweed cultivation – CSIR-CSMCRI Marine Algal Research Station, Mandapam, Ramanathapuram, Tamilnadu",
            "Completed Open Water Diver course – Seven Seas Dive Academy, Kalpeni (2022)",
            "Completed Advanced Open Water Diver course – Lak Scuba Dive Resort, Kavaratti (2023)",
          ],

          description: "Working on field research and biodiversity projects.",
          fullProfile1:
            "BSc. Biotechnology and Botany (2018-21) from St. Berchmans College, Chanaganassery, Kottayam, Kerala.\nMSc. Marine Biology (2022-24) from Kerala University of Fisheries and Ocean Studies (KUFOS), Panangad, Kochi, Kerala.\nOne year research experience in Seaweed cultivation from CSIR-CSMCRI Marine Algal Research Station, Mandapam, Ramanathapuram, Tamilnadu.",

          fullProfile2:
            "Achievements and awards:\n\n● Completed hands-on training programme in “Introduction to Nanotechnology; its application in fisheries and allied subjects” at ICAR-CENTRAL INSTITUTE OF FISHERIES TECHNOLOGY (CIFT), Kochi, Kerala.\n● Won the best project presentation award in Nanotechnology application in Fisheries and allied subjects from ICAR-CIFT.\n● Participated in “National Conference on Marine Pollution and Ecotoxicology 2024” at Cochin University of Science and Technology (CUSAT), Kochi, Kerala.",

          fullProfile3:
            "Diving Certification:\n\nCompleted Open Water Diver course from Seven Seas Dive Academy, Kalpeni (2022).\nCompleted Advanced Open Water Diver course from Lak Scuba Dive Resort, Kavaratti (2023).\n\nI’m passionate about Seaweed cultivation, underwater photography and filmmaking, and Coral Reef Conservation.",
        },
        {
          src: img9,
          name: "MOHAMMED SHAHEEM P",
          position:
            "Project Coordinator, Research and Environmental Education Foundation (REEF)",
          email: "shaheempokkilakam@gmail.com",
          qualifications: [
            "Graduate degree in Botany – Government Victoria College, Palakkad",
            "Postgraduate degree in Botany – Government Victoria College, Palakkad",
            "Diploma in Elementary Education – Farook College",
            "Diploma in Computer Applications (Accountings)",
          ],

          description: "Coordinates various conservation projects.",
          fullProfile1:
            "Mohammed Shaheem P serves as Project Coordinator at the Research and Environmental Education Foundation (REEF), where he leads initiatives focused on environmental education, conservation, and community engagement.\n\nHe holds both graduate and postgraduate degrees in Botany from Government Victoria College, Palakkad, along with a Diploma in Elementary Education from Farook College and a Diploma in Computer Applications (Accountings).",

          fullProfile2:
            "Shaheem’s dedication to conservation and education has been recognized through several awards, including the Green Olympiad, Federal Bank–Malayala Manorama Public Speech Award, Interschool Chess Championship, and the Bommitra Scena Best Conservation Award.",

          fullProfile3:
            "Guided by the belief that “There is no home other than Mother Earth,” he continues to work passionately towards fostering awareness and sustainable practices for the protection of natural ecosystems.",
        },
        {
          src: img8,
          name: "Safair Ali Jereesh",
          position: "Environmental Education Coordinator, REEF",
          email: "nowshad@example.org",
          qualifications: [
            "Bachelor’s degree in Zoology",
            "Master’s degree in Mass Communication and Journalism",
          ],

          description: "Focuses on education outreach programs.",
          fullProfile1:
            "Environmental Education Coordinator with 11+ years of experience in journalism, media, and community engagement. At REEF, I lead educational programs, workshops, and awareness campaigns focused on marine conservation, sustainable fisheries, and climate resilience in Lakshadweep.\n\nWith a background in Zoology and a Master’s in Mass Communication and Journalism, I specialize in creating culturally relevant content that connects science with people. I work closely with women’s groups, fishers, youth, and government departments to promote ocean literacy and sustainable livelihoods.",

          fullProfile2:
            "I’ve assisted marine researcher Rucha Karkare in field studies at Kadmat Island and directed the documentary “Gold on Rocks” on mussel farming.",

          fullProfile3:
            "Honors & Awards\n\nShuttle Badminton Champion – St. Joseph’s College, Irinjalakuda\nShuttle Badminton Champion – Kadalundi Grama Panchayath\nShuttle Badminton Champion – Lakshadweep Administration",
        },
        {
          src: img7,
          name: "Abdulla",
          position: "Executive Member and MSDT Instructor",
          email: "nowshad@example.org",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut",
          ],
          description: "Trains and educates divers.",
        },
        {
          src: img2,
          name: "Ilthmish Nasarulla",
          position: "REEF Dive Master",
          email: "nowshad@example.org",
          qualifications: [
            "Specialized training with BNHS (Bombay Natural History Society)",
            "Training with LCRMN (Lakshadweep Coral Reef Monitoring Network)",
            "Training with S&D Coral Repletion",
            "Training from Indo–Australia Coral Reef Monitoring Training Program",
          ],

          description: "Responsible for underwater research dives.",
          fullProfile1:
            "Ilthuthmish Nasarulla M. P serves as Dive Master at the Research and Environmental Education Foundation (REEF).",

          fullProfile2:
            "He has received specialized training through programs with BNHS, LCRMN, S&D Coral Repletion, and the Indo–Australia Coral Reef Monitoring Training Program,",

          fullProfile3:
            "contributing his expertise to coral reef monitoring and conservation efforts.",
        },
        {
          src: img1,
          name: "Sharafudheen KM",
          position: "Dive Assistant, REEF Agatti",
          email: "rowsha155@gmail.com",
          qualifications: [
            "Certified Advanced Open Water Diver",
            "Experience with Lakshadweep Coral Reef Monitoring Network (LCRMN)",
            "Worked with Science & Technology Department (2006–2013)",
            "Worked with Environment & Forest Department (2013–2021)",
          ],

          description: "Supports diving and field work.",
          fullProfile1:
            "Sharafudheen K. M serves as Dive Assistant at the Research and Environmental Education Foundation (REEF), Agatti.",

          fullProfile2:
            "He has extensive experience with the Lakshadweep Coral Reef Monitoring Network (LCRMN), having worked with the Science & Technology Department (2006–2013) and the Environment & Forest Department (2013–2021).",

          fullProfile3:
            "A certified Advanced Open Water Diver, he brings valuable field expertise to reef monitoring and conservation activities.",
        },
        {
          src: img13,
          name: "Mohammed Nisham.P. P",
          position: "Dive Assistant",
          email: "nishampepe@gmail.com",
          qualifications: ["Certified Open Water Diver"],

          description: "Assists in dive missions and logistics.",
          fullProfile1:
            "Mohammed Nisham P. P serves as Dive Assistant at the Research and Environmental Education Foundation (REEF), Agatti.",

          fullProfile2:
            "He is a certified Open Water Diver and actively supports reef conservation and monitoring activities through his field expertise.",

          fullProfile3: "",
        },
        {
          src: img6,
          name: "Ajmeer Khan",
          position: "Field Assistant, REEF Agatti",
          email: "ajmeer@gmail.com",
          qualifications: ["Certified Open Water Diver"],

          description: "Supports field research activities.",
          fullProfile1:
            "Mohammed Nisham P. P serves as Dive Assistant at the Research and Environmental Education Foundation (REEF), Agatti.",

          fullProfile2:
            "He is a certified Open Water Diver and actively supports reef conservation and monitoring activities through his field expertise.",

          fullProfile3: "",
        },
        {
          src: img5,
          name: "Mukbil",
          position:
            "Field Assistant, Research and Environment Education Foundation (REEF)",
          email: "mukhbilbaba@gmail.com",
          qualifications: [
            "Diesel Mechanic certification",
            "Advanced Diploma in Oil & Gas",
            "Scuba Advanced Open Water Diver",
            "1 Year – Fisheries Marine Mechanic Workshop Apprentice Training",
            "2 Years – Lakshadweep Electricity Apprenticeship Training",
            "3 Years – Coral Monitoring Staff – Zoological Survey of India",
            "5 Years – Scuba Diving Field Experience",
          ],

          description: "Engaged in on-site conservation tasks.",
          fullProfile1:
            "Field Assistant with over 10 years of combined technical and marine field experience in diesel mechanics, oil & gas, electricity apprenticeship, coral monitoring, and scuba diving. At REEF, I support marine research, reef monitoring, and environmental education programs aimed at conserving fragile ecosystems in Lakshadweep.\n\nWith a background in Diesel Mechanic and an Advanced Diploma in Oil & Gas, along with hands-on training in fisheries marine workshops and the Lakshadweep Electricity Department, I bring strong technical problem-solving skills to field operations.",

          fullProfile2:
            "I have worked as Coral Monitoring Staff at the Zoological Survey of India (ZSI) for three years, contributing to reef conservation and scientific studies. In addition, I am a Scuba Advanced Open Water Diver with five years of practical experience, supporting underwater monitoring, reef restoration, and marine awareness activities.",

          fullProfile3:
            "I am passionate about combining technical expertise with marine conservation, and I continue to work closely with researchers, community groups, and institutions to protect ocean resources for future generations."
        },
      ],
    },
  ];

  return (
    <>
      <Header />

      {/* Hero Section - scrolls away normally */}
      <Box
        sx={{
          width: "100%",
          height: isMobile ? "50vh" : "65vh",
          position: "relative",
        }}
      >
        <ScrollContainer ref={scrollRef}>
          {images.map((img, index) => (
            <ScrollItem key={index}>
              <ScrollImage src={img} alt={`Banner ${index + 1}`} />
            </ScrollItem>
          ))}
        </ScrollContainer>

        <DotsContainer>
          {images.map((_, idx) => (
            <Dot
              key={idx}
              active={currentIndex === idx}
              onClick={() => handleDotClick(idx)}
            />
          ))}
        </DotsContainer>
      </Box>

      {/* Main Content Section */}
      <Grid
        container
        sx={{
          px: isMobile ? 2 : 4,
          py: isMobile ? 2 : 4,
          position: "relative",
          maxWidth: "100%",
          margin: "0 auto",
          bgcolor: "#f5f5f5",
        }}
      >
        {/* Left Side Navigation - Sticky */}
        {!isMobile && (
          <Grid
            item
            md={2}
            sx={{
              position: "sticky",
              top: 80,
              height: "calc(100vh - 64px)",
              alignSelf: "flex-start",
              overflowY: "auto",
              zIndex: 1,
              pr: 2,
            }}
          >
            <LeftSideNavigation />
          </Grid>
        )}

        {/* Right Side Content - Scrollable */}
        <Grid
          item
          xs={12}
          md={10}
          sx={{
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            borderRadius: "12px",
            overflowY: "auto",
            scrollbarWidth: "none",
            backgroundColor: "#ffffff",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            marginBottom: "24px",
          }}
        >
          <Box
            sx={{
              color: "#7f6b56",
              fontFamily: "Inter, sans-serif",
              px: isMobile ? 2 : 3,
              py: isMobile ? 3 : 6,
              position: "relative",
            }}
            ref={contentRef}
          >
            {teamCategories.map((category, catIndex) => (
              <Grid
                key={catIndex}
                item
                xs={12}
                sx={{
                  px: 3,
                  py: 4,
                  justifyContent: "center",
                  borderBottom:
                    catIndex !== teamCategories.length - 1
                      ? "1px solid #e0e0e0"
                      : "none",
                }}
              >
                <Typography
                  variant={isMobile ? "h5" : "h4"}
                  align="center"
                  gutterBottom
                  sx={{
                    fontWeight: "bold",
                    mb: 6,
                    fontFamily: "Montserrat, sans-serif",
                    color: "#000",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                    position: "relative",
                    "&:after": {
                      content: '""',
                      display: "block",
                      width: "80px",
                      height: "4px",
                      backgroundColor: theme.palette.primary.main,
                      margin: "16px auto 0",
                      borderRadius: "2px",
                    },
                  }}
                >
                  {category.title}
                </Typography>
                <Grid container spacing={4} justifyContent="center">
                  {category.members.map((member, memIndex) => {
                    const globalIndex = `${catIndex}-${memIndex}`;
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={member.name}
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <Box
                          sx={{
                            width: 280,
                            height: "100%",
                            borderRadius: "12px",
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              transform: "translateY(-8px)",
                              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
                            },
                          }}
                          onClick={() =>
                            navigate(`/profile/${globalIndex}`, {
                              state: { member },
                            })
                          }
                        >
                          <Box
                            sx={{
                              height: 360,
                              overflow: "hidden",
                              flexShrink: 0,
                              position: "relative",
                              "&:before": {
                                content: '""',
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                right: 0,
                                height: "40%",
                                background:
                                  "linear-gradient(to top, rgba(0,0,0,0.5), transparent)",
                                zIndex: 1,
                              },
                              "& img": {
                                transition: "transform 0.5s ease",
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              },
                              "&:hover img": {
                                transform: "scale(1.1)",
                              },
                            }}
                          >
                            <img src={member.src} alt={member.name} />
                          </Box>
                          <Box
                            sx={{
                              p: 2,
                              backgroundColor: "#fff",
                              borderTop: `4px solid ${theme.palette.primary.main}`,
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              fontWeight="bold"
                              color="#000"
                              sx={{
                                fontFamily: "Montserrat, sans-serif",
                                mb: 0.5,
                                fontSize: "1.1rem",
                              }}
                            >
                              {member.name}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{
                                fontFamily: "Montserrat, sans-serif",
                                letterSpacing: 0,
                                fontSize: "0.9rem",
                              }}
                            >
                              {member.position}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            ))}
          </Box>
        </Grid>

        {/* Mobile Navigation - appears after content */}
        {isMobile && (
          <Grid item xs={12} sx={{ mt: 2 }}>
            <LeftSideNavigation />
          </Grid>
        )}
      </Grid>

      <Footer variant="light" />
    </>
  );
};

export default Project;
